import React from 'react';

import { useApplicationState } from '@atlas/core';

import RealityCheckOld from './RealityCheckOld';
import RealityCheckV2 from './RealityCheckV2';

const RealityCheck = () => {
  const {
    account: { realityCheckConfigurationEnabled },
  } = useApplicationState();

  if (realityCheckConfigurationEnabled) {
    return <RealityCheckV2 />;
  }

  return <RealityCheckOld />;
};

export default RealityCheck;
